import type { PrefabData } from "./prefabData";
import { MossBrick } from "../../things/mossBrick";
import { Sculpture1 } from "../../things/sculpture1";
import { WavyTile } from "../../things/floors/wavyTile";

export const lTunnelData: PrefabData = {
	legend: {
		".": "ConcreteFloor",
		"#": "MetalBlock",
	},
	layout: ["#.#   ", "#.####", "#.....", "######"],
};

export const lTunnel2Data: PrefabData = {
	legend: {
		".": "ConcreteFloor",
		"#": "MetalBlock",
	},
	layout: ["#.#    ", "#.#####", "#......", "###.###", "  #.#  "],
};

export const lavaCrossData: PrefabData = {
	legend: {
		F: "FireTower",
		U: "LavaPool",
	},
	layout: ["FUF", "UUU", "FUF"],
};

export const fireTowerChasmData: PrefabData = {
	legend: {
		V: "Chasm",
		F: "FireTower",
	},
	layout: ["VVV", "VFV", "VVV"],
};

export const caveArrivalData: PrefabData = {
	legend: {
		"/": "BlastDoor",
		"#": "ConcreteBlock",
		".": "ConcreteFloor",
		E: "EmptyBarrel",
		$: "LootBox",
		O: "OpenBlastDoorsTerminal",
		U: { class: "Upstairs", props: { destination: 0 } },
		"+": "WoodenDoor",
	},
	layers: [
		[
			"       ",
			"  ...  ",
			"  ...  ",
			"  ...  ",
			"   .   ",
			" ..... ",
			" ......",
			" ..... ",
			"   .   ",
			"  ...  ",
			"  ...  ",
			"  ...  ",
			"  ...  ",
			"       ",
		],
		[
			" ##### ",
			" #E$$# ",
			" #E O# ",
			" #E  # ",
			"###+###",
			"#E    #",
			"#U    /",
			"#E    #",
			"###+###",
			" #E E# ",
			" #E E# ",
			" #$ $# ",
			" #$$$# ",
			" ##### ",
		],
	],
};

export const sculptures3Data: PrefabData = {
	legend: {
		"#": MossBrick.key,
		S: Sculpture1.key,
		".": WavyTile.key,
	},
	layers: [
		[
			"         ",
			"........ ",
			".........",
			" ........",
			"         ",
		],
		[
			"#########",
			"        #",
			"  S S S  ",
			"#        ",
			"#########",
		],
	],
};

export const chasmLootData: PrefabData = {
	legend: {
		V: "Chasm",
		$: "LootBox",
		M: "MetalLootBox",
		".": "WoodenBridgeFloor",
	},
	layout: ["  VV.VV  ", "VVV   VVV", "VV $$$ VV", "VVVMMMVVV", " VVVVVVV "],
};
